<template><!--个人中心》我的钱包》积分转余额-->
    <div class="integralWithdraw il-pad" style="background-color:#ffffff">
        <div v-if="page_type == 1" style="height:332px;">
            <div class="il-box dis-between">
                <div class="dis" style="margin:auto 0" >
                    <div class="il-p">提现到账户余额</div>
                    <div class="il-p2">余额将实时到账</div>
                </div>
                <div style="margin:auto 0;color:#11D165;cursor:pointer" @click="recordFn">提现记录</div>
            </div>
            <div class="group" style="margin-left:24px">
                <div>
                    <div class="il-p3">提现积分（金额）</div>
                    <div style="margin-top:24px">
                        <div class="il-box2 dis" style="width:100%;">
                            <img style="width:29px;height:35px;margin:auto 20px auto 0" src="../../../assets/image/iocn/¥.png" />
                            <input type="number" class="il-input" style="width:85%;text-align:left;font-size:48px;color:#333333" v-model="input_value" placeholder="" />
                        </div>
                        <div style="margin-top:23px;color:#999999">当前积分余额{{myBalance.tokenmoney}}分，<span style="margin:auto 0;color:#11D165;cursor:pointer" @click="allClick">全部提现</span></div>

                        <div class="il-but" @click="nextClick">提现</div>
                    </div>
                </div>
            </div>
        </div>
        <!------------------------------------------------------>
        <!--请输入支付密码-->
        <div
            class="reg-popup-bac req-popup-pos"
            v-if="is_zhifuPopup"
        ></div>
        <div
            class="req-popup-pos reg-popup-wid dis-cen"
            v-if="is_zhifuPopup"
        >
            <div class="reg-popup-box" style="height:auto;border-radius:0">
                <div class="dis-between">
                    <div @click="wjpasswordClick" style="color:#11D165;cursor: pointer;">设置支付密码</div>
                    <div style="font-size: 22px;">支付密码</div>
                    <div class="dis-end" style="width:96px"><img class="reg-popup-box-close" style="cursor: pointer;" @click="closePopupImgClick" src="../../../assets/image/iocn/close.png" /></div>
                </div>
                <div class="dis-cen" style="font-size: 18px;text-align: center;margin-top:19px">
                    <div class="dis">
                        <div style="font-size:48px;color:#333333">¥{{input_value}}<span style="font-size:18px;color:#333333;margin-left:24px ">提现到余额</span></div>
                    </div>
                </div>
                <div id="payPwd" style="margin: 60px 15%">
                    <input ref="pwd" type="password" maxlength="6" v-model="msg"  style="position: absolute;z-index: -1;left:-100%;opacity: 0"/>
                    <ul class="pwd-wrap" @click="focus">
                    <li><i v-if="msgLength > 0"></i></li>
                    <li><i v-if="msgLength > 1"></i></li>
                    <li><i v-if="msgLength > 2"></i></li>
                    <li><i v-if="msgLength > 3"></i></li>
                    <li><i v-if="msgLength > 4"></i></li>
                    <li><i v-if="msgLength > 5"></i></li>
                    </ul>
                </div>
                <div class="dis-cen">
                    <div v-if="!is_loading" class="withdra-color withdra-but" @click="checkClick">提交</div>
                    <div v-else class="withdra-color withdra-but" style="background-color: #cacaca;">加载中...</div>
                </div>
            </div>
        </div>
        <!--温馨提示-->
        <div
            class="reg-popup-bac req-popup-pos"
            v-if="is_Popup"
        ></div>
        <div
            class="req-popup-pos reg-popup-wid dis-cen"
            v-if="is_Popup"
        >
            <div class="reg-popup-box" style="height:auto;border-radius:0">
                <div class="dis-between">
                    <div style="width:96px"></div>
                    <div style="font-size: 22px;">温馨提示</div>
                    <div class="dis-end" style="width:96px"><img class="reg-popup-box-close" style="cursor: pointer;" @click="readFn" src="../../../assets/image/iocn/close.png" /></div>
                </div>
                <div style="margin: 60px 15%;font-size:25px">
                    提现已成功，是否继续提现？
                </div>
                <div class="dis-cen" style="width:100%">
                    <div class="dis" style="margin-top:23px">
                        <div class="details-info-wid-botton" style="background: #11D165;" @click="readFn">确定</div>
                        <div class="details-info-wid-botton2" style="line-height:38px" @click="routerTxClick">提现记录</div>
                    </div>
                </div>
            </div>
        </div>


        <!---------->
        <!-- <div v-if="page_type == 2" style="height:500px;">
         
        </div> -->
        <div v-if="page_type == 3">
            <div class="rechargeRecord">
                <div class="transaction-tips dis-between">
                    <div class="dis">
                        <img class="jfzz-img" style="cursor:pointer;" @click="closeClick" src="../../../assets/image/iocn/close.png" />
                        <div class="jfzz-p">积分转余额记录</div>
                    </div>
                    <div class="dis">
                        <div class="transaction-record-title" style="margin: auto 0;color:#484848">筛选：</div>
                        <div class="found-time-box">
                            <el-date-picker
                                v-model="value2"
                                type="datetimerange"
                                :picker-options="pickerOptions"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                align="right"
                                @change = "pickerReadClick"
                            ></el-date-picker>
                        </div>
                    </div>
                </div>
                <div style="height:24px"></div>
                <div v-if="rechargeList.length > 0">
                    <div class="dis-between" style="padding: 13px 24px;box-sizing: border-box;font-size:14px">
                        <div class="dis-cen" style="width:200px">订单号</div>
                        <div class="iwd-wid dis-cen">积分</div>
                        <!-- <div class="iwd-wid dis-cen">倍率</div> -->
                        <div class="iwd-wid dis-cen">余额(元)</div>
                        <div class="dis-cen" style="width:160px">操作时间</div>
                    </div>
                    <div v-for="(item,index) in rechargeList" :key="index" class="group jfzz-box dis-between">
                        <div class="dis-cen" style="width:200px">{{item.orderNo}}</div>
                        <div class="iwd-wid dis-cen">{{item.tokenMoney}}</div>
                        <!-- <div class="iwd-wid dis-cen">{{item.point}}%</div> -->
                        <div class="iwd-wid dis-cen" style="color:#11D165">+{{item.addBalance}}</div>
                        <div  style="width:160px">{{item.addTime}}</div>
                    </div>
                </div>
                <div v-else style="text-align:center;line-height:350px">暂无数据</div>
                <div class="list-page dis-end myBalance-pagination" style="margin-top:24px">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="totalLength"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .il-pad{padding:24px;box-sizing: border-box;}
    .il-box{padding:0 24px;box-sizing: border-box;height: 56px;background: #F1F1F1;}
    .il-p{margin-right:23px;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #434343;}
    .il-p2{font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #999999;}
    .il-p3{margin-top:40px;margin-right:20px;font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #6F6F6F;}
    .il-box2{width: 712px;height: 56px;border-bottom:1px solid #f1f1f1}
    .il-input{font-size: 18px; text-align: center;width:100%;height:54px;border:none;outline: none;}
    .il-but{text-align: center;line-height: 40px;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #FFFFFF;margin-top:40px;width: 160px;height: 40px;background: #11D165;cursor: pointer;}

    input:focus{outline:medium;}
    .userrec-wid{width:100%;line-height:56px;background: #F1F1F1;font-size: 18px;padding-left:24px;font-family: PingFang SC;font-weight: 500;color: #434343;line-height: 56px;}
    .userrec-img{width:24px;height:26px;margin:auto 0;margin-right:23px}
    .userrec-box{text-align: center;font-size: 22px;font-family: PingFang SC;font-weight: 500;color: #999999;line-height: 78px;width: 160px;height:80px;border:1px solid #CACACA;cursor: pointer;margin-right: 24px;}
    .userrec-act-bor{border: 2px solid #11D165;color:#11D165}.userrec-color{color: #999999;}.userrec-act-color{color: #11D165;}
    .userrec-img2{position: relative;top:-26px;z-index: 3;}
    .userrec-input{width:80%;margin:auto 0;height:30px;border:none;color:#11D165;font-size: 22px;}

    .il-p4{font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #333333;margin:auto 24px}
    .list-page >>> .el-pagination .btn-prev {margin-right: 5px;}
    .iwd-wid{width:92px}
    /*********************************************************** */
    .dis-end {
        display: flex;
        justify-content: flex-end;
    }

    .dis-ju2 {
        display: flex;
        flex-direction: column;
    }

    .dis-cen {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center
    }
    .userrec-wid{width:100%;line-height:56px;background: #F1F1F1;font-size: 18px;padding-left:24px;font-family: PingFang SC;font-weight: 500;color: #434343;line-height: 56px;}
    #payPwd .pwd-wrap{
        /* width: 90%; */
        height: 44px;
        padding-bottom: 1px;
        margin: 0 auto;
        background: #fff;
        /* border:1px solid #ddd; */
        display: flex;
        display: -webkit-box;
        display: -webkit-flex;
        cursor: pointer;
    }
    .pwd-wrap li{
        list-style-type:none;
        text-align: center;
        line-height: 44px;
        -webkit-box-flex: 1;
        flex: 1;
        -webkit-flex: 1;
        /* border-right:1px solid #ddd ; */
        background: #f2f2f2;
        margin: 0 10px;
    }
    .pwd-wrap li:last-child{
        border-right: 0;
    }
    .pwd-wrap li i{
        height: 10px;
        width: 10px;
        border-radius:50% ;
        background: #000;
        display: inline-block;
    }

</style>

<script>
import imgcode from '../../imgcode.vue';
    export default
    {
	components: { imgcode },
        name: 'integralWithdraw',
        props: { parentName: { type: Object } },
        data()
        {
            return {
                is_Popup: false,
                is_loading: false,
                is_zhifuPopup: false,
                msg:'',
                msgLength: 0,
                // +---------------------------
                page_type: 1,
                myBalance: {},
                input_value: '',
                //+--------------------------------------------------------
                pickerOptions: {
                    shortcuts: [
                        {
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 7
                                )
                                picker.$emit("pick", [start, end])
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 30
                                )
                                picker.$emit("pick", [start, end])
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 90
                                )
                                picker.$emit("pick", [start, end])
                            }
                        }
                    ]
                },
                value2: "",
                rechargeList: [], //充值记录
                DateStart: '',
                DateEnd: '',
                pageNo: 1,
                totalPage: 0, //总页数
                pageSize: 10,
                totalLength: 0, //总条数
                currentPage: 1,
                new_vipCard: 0,
                //+--------------------------------------------------------
                bol: false,
            };
        },
        watch:{
            msg(curVal){
                if(/[^\d]/g.test(curVal)){
                this.msg = this.msg.replace(/[^\d]/g,'');
                }else{
                    this.msgLength = curVal.length;
                }
            },
        },
        created()
        {
            this.getBalance()
        },
        methods:
        {
            getBalance() {
                this.$api.order.UserBalances().then(res => {
                    if (res.data.code == 0) {
                        this.myBalance = res.data.result
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "warning")
                    }
                })
            },
            allClick() {
                this.input_value = this.myBalance.tokenmoney
            },
            // +-----------------------------------------
            wjpasswordClick() {    
                this.$router.push(
                {
                    path: "/order?index=0&personal=4"
                } )
            },
            closePopupImgClick() {
                this.msg = ''
                this.is_zhifuPopup = false
                this.is_loading = false
            },
            focus(){
                this.$refs.pwd.focus();
            },
            checkClick() {
                this.is_loading = true
                let params = {PayPwd: this.msg}
                this.$api.product.VerifyPayPwd(params).then((res) => {
                    if ( res.data.code == 0 )
                    {
                        this.reqFn()
                    }else
                    {
                        let name = res.data.message;
                        this.checkTips( name, 'warning' );
                        this.is_loading = false
                    }
                })
            },
            // +---------------------------------------
            nextClick() {
                if (!this.input_value) {
                    this.checkTips( "请输入提现值", 'warning' );
                    return
                }
                if (this.input_value < 100 || this.input_value % 10 ) {
                    this.checkTips( "值不得小于100且为整10的倍数", 'warning' );
                    return
                }
                this.is_zhifuPopup = true
            },
            reqFn() {
                let paramsTwo = {
                    tokenmoney: this.input_value,
				}

                this.$api.product.UserTKMToBalTrade(paramsTwo).then(res => {
					this.$loading().close()
					if (res.data.code == 0) {
                        this.closePopupImgClick()
                        this.checkTips( '积分转让成功', 'success' );
                        this.getBalance()
                        this.is_Popup = true
					} else {
						let name = res.data.message
						this.checkTips(name, "warning")
					}
				})
            },
            // +---------------------------------------------------------
            closeClick() {
                this.page_type = 1
                this.input_value = ''
            },
            recordFn() {
                this.page_type = 3
                this.new_vipCard = localStorage.getItem( 'vipCard' )
                this.choosestatus(1)
            },
            choosestatus(val) {
                if (val) {
                    this.pageNo = 1
                    this.currentPage = 1
                    this.totalLength = 0
                }
            
                this.getRechargeList()
            },
            getRechargeList() {
                this.$loading()
                let params = {
                    PageNo: this.pageNo,
                    PageSize: this.pageSize,
                    Params: {
                        DateStart: this.DateStart,
                        DateEnd: this.DateEnd
                    }
                }
                this.$api.product.GetUserTkmtobalList(params).then(res => {
                    this.$loading().close()
                    if (res.data.code == 0) {
                        this.rechargeList = res.data.result.data;
                        let totalcount = res.data.result.totalCount;
                        this.totalLength = totalcount;
                        // 计算一共有几页
                        this.totalPage = Math.ceil( totalcount / this.pageSize );
                        // 计算得0时设置为1
                        this.totalPage = this.totalPage == 0 ? 1 : this.totalPage;
                    } else {
                        this.checkTips(res.data.message, "warning")
                    }
                })
            },
            readFn() {
                this.is_Popup = false
                this.closeClick()
            },
            routerTxClick() {
                this.is_Popup = false
                this.recordFn()
            },
            pickerReadClick() {
                if (this.value2 == null) {
                    this.DateStart = ''
                    this.DateEnd = ''
                    this.choosestatus(1)
                    return
                }

                this.DateStart = this.formatDate(this.value2[0])
                this.DateEnd = this.formatDate(this.value2[1])
                this.choosestatus(1)
            },
            //将中国标准时间转换为年月日格式
            formatTen(num) { 
                return num > 9 ? (num + "") : ("0" + num); 
            },
            formatDate(date) { 
                var year = date.getFullYear(); 
                var month = date.getMonth() + 1; 
                var day = date.getDate(); 
                var hour = date.getHours(); 
                var minute = date.getMinutes(); 
                var second = date.getSeconds(); 
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day)+ " " + this.formatTen(hour)+ ":" + this.formatTen(minute)+ ":" + this.formatTen(second); 
            },
            handleSizeChange( val )
            {
                console.log( `每页 ${val} 条` );
            },
            handleCurrentChange( val )
            {
                this.pageNo = val;
                this.choosestatus()
                // console.log( `当前页: ${val}` );
            },
            // +---------------------------------------------------------
            checkTips( name, type )
            { //用户提示
                this.$message(
                {
                    message: name,
                    type: type
                } )
            },
            wjpasswordClick() {
                this.closeaddress(4)
            },
            // +--------------------------------------
            closeaddress(val)
            {
                this.$emit( 'childFn', val )
            }

        }
    }
</script>